module.exports = __webpack_public_path__ + "img/logo.ece8b060.png";